// extracted by mini-css-extract-plugin
export default {"form":"w7w43l mz-default-dark-font","form--mobile":"zVnA1X","field":"JzAIEW","usingTool":"Ts2Vzt","link":"N5jBZ9 mz-link","spaced":"p3uVVh"};